// src/slices/userProfile/thunk.ts
// Async thunks for User Profile

import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getUserProfile,
  updateUserProfile,
  uploadCurrentUserAvatar,
} from 'helpers/fakebackend_helper';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('user_profile_messages');

// Fetch current user profile
export const fetchUserProfile = createAsyncThunk(
  'userProfile/fetchProfile',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getUserProfile();
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(
        error?.message || st('co_loi_xay_ra_khi_tai_message')
      );
    }
  }
);

// Update current user profile
export const updateProfile = createAsyncThunk(
  'userProfile/updateProfile',
  async ({ userId, data }: { userId: number; data: any }, { rejectWithValue }) => {
    try {
      const response = await updateUserProfile(userId, data);
      return response.data || response;
    } catch (error: any) {
      return rejectWithValue(
        error?.message || st('co_loi_xay_ra_khi_cap_message')
      );
    }
  }
);

// Upload current user avatar
export const uploadProfileAvatar = createAsyncThunk(
  'userProfile/uploadAvatar',
  async ({ userId, file }: { userId: number; file: File }, { rejectWithValue }) => {
    try {
      const response = await uploadCurrentUserAvatar(userId, file);
      const data = response.data || response;
      // Return the real FileStorage URL
      return data.avatarUrl;
    } catch (error: any) {
      return rejectWithValue(
        error?.message || st('co_loi_xay_ra_khi_tai_message_2')
      );
    }
  }
);